class i {
  storage;
  userId = "";
  privateKeys;
  constructor(e, t = []) {
    this.storage = e, this.privateKeys = t;
  }
  isPrivateKey = (e) => this.privateKeys.some((t) => t === e);
  getProperty = (e) => this.isPrivateKey(e) && this.userId ? `${e}_${this.userId}` : e;
  setValue = (e, t) => {
    const s = this.getProperty(e);
    this.storage.set(s, t);
  };
  getValue = (e) => {
    const t = this.getProperty(e);
    return this.storage.get(t);
  };
  hasValue = (e) => {
    const t = this.getProperty(e);
    return this.storage.has(t);
  };
  deleteValue = (e) => {
    const t = this.getProperty(e);
    this.storage.delete(t);
  };
  deleteOtherAccountData = () => {
    const e = this.storage.getAll();
    for (const t of Object.keys(e))
      this.isPrivateKey(t) && !t.endsWith(this.userId) && this.storage.delete(t);
  };
  setUserId = (e) => {
    this.userId = e, this.deleteOtherAccountData();
  };
  getUserId = () => this.userId;
}
export {
  i as BaseStorageService
};
//# sourceMappingURL=BaseStorageService.mjs.map
